import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, filter } from 'rxjs';

import { WebsocketService } from '@core/services/websocket.service';
import { CONFIG_TOKEN } from '@core/tokens';

import {
  DashboardOverviewResponse,
  DashboardOverviewWebsocketMessage,
  DashboardStats,
  DateRangeRequest,
  EnergyCostResponse,
  VehicleStateOfChargeSummaryResponse,
} from './multi-site-dashboard.models';

@Injectable({
  providedIn: 'root',
})
export class MultiSiteDashboardService {
  readonly #ROOT_URL = inject(CONFIG_TOKEN).backendRootUrl;

  readonly #httpClient = inject(HttpClient);
  readonly #websocketService = inject(WebsocketService);

  public getOverview$(tenantId: string): Observable<DashboardOverviewResponse> {
    return this.#httpClient.get<DashboardOverviewResponse>(`${this.#ROOT_URL}/api/v1/dashboard/${tenantId}/overview`);
  }

  public getOverviewWebsocketMessage$(tenantId: string): Observable<DashboardOverviewWebsocketMessage> {
    return this.#websocketService
      .connectToTopic$<DashboardOverviewWebsocketMessage>(`dashboard/${tenantId}/overview`)
      .pipe(filter((message) => message.type === 'dashboar-overview'));
  }

  public getStats$(tenantId: string): Observable<DashboardStats> {
    return this.#httpClient.get<DashboardStats>(`${this.#ROOT_URL}/api/v1/dashboard/${tenantId}/stats`);
  }

  public getEnergyCost$(tenantId: string, request?: DateRangeRequest): Observable<EnergyCostResponse> {
    return this.#httpClient.get<EnergyCostResponse>(`${this.#ROOT_URL}/api/v1/dashboard/${tenantId}/energy-cost`, {
      params: this.#getParamsFromDateRangeRequest(request),
    });
  }

  public getVehicleStateOfChargeSummary$(tenantId: string, request?: DateRangeRequest): Observable<VehicleStateOfChargeSummaryResponse> {
    return this.#httpClient.get<VehicleStateOfChargeSummaryResponse>(
      `${this.#ROOT_URL}/api/v1/dashboard/${tenantId}/vehicle-state-of-charge-summary`,
      { params: this.#getParamsFromDateRangeRequest(request) }
    );
  }

  #getParamsFromDateRangeRequest(request?: DateRangeRequest): HttpParams {
    let params = new HttpParams();
    if (request?.start) {
      params = params.append('start', request.start);
    }
    if (request?.end) {
      params = params.append('end', request.end);
    }

    return params;
  }
}
